// ABOUTME: Resolves the route the `*` catch-all redirects to, from the defaultPageUri setting, the
// ABOUTME: company override and the built-in fallback, never landing on a Hierarchies page it may not open.

export interface DefaultPageUri {
    uri: string;
    roleOverrides?: Array<{ role: string; uri: string }> | null;
}

export interface GetDefaultRouteOptions {
    isAdmin: boolean;
    companyDefaultRoute?: string | null;
    defaultPageUri?: DefaultPageUri | null;
    hasUserRole?: (role: string) => boolean;
    canAccessHierarchies: boolean;
    firstCustomPageSlug?: string | null;
}

const isHierarchiesPath = (uri: string) => /^\/?hierarchies(\/|\?|$)/.test(uri);

export function getDefaultRoute({
    isAdmin,
    companyDefaultRoute,
    defaultPageUri,
    hasUserRole,
    canAccessHierarchies,
    firstCustomPageSlug,
}: GetDefaultRouteOptions): string {
    const allowed = (uri?: string | null): uri is string =>
        !!uri && (canAccessHierarchies || !isHierarchiesPath(uri));

    if (defaultPageUri?.roleOverrides && hasUserRole) {
        const match = defaultPageUri.roleOverrides.find(r => hasUserRole(r.role) && allowed(r.uri));
        if (match) return match.uri;
    }
    if (allowed(defaultPageUri?.uri)) {
        return defaultPageUri.uri;
    }
    if (allowed(companyDefaultRoute)) {
        return companyDefaultRoute;
    }
    if (isAdmin) return '/language';
    if (canAccessHierarchies) return '/hierarchies';
    return firstCustomPageSlug ? `/pages/${firstCustomPageSlug}` : '/profile';
}
